export default __webpack_public_path__ + "static/media/infiniti.de991455.svg";